export type NotNull<T>	= T & ({} | undefined);

export namespace NotNull {
	export const is		= <T>(it:T|null): it is T	=> it !== null;

	export const unsafe	= <T>(it:T|null):T	=> {
		if (it === null)	throw new Error("unexpected null value");
		return it as T;
	};
}
